import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { cloneDeep } from 'lodash';
import { AdministratorService } from 'libs/data/src/lib/services/administrator/administrator.service';

@Component({
  selector: 'piqet-angular-grid-cell-dropdown',
  templateUrl: './grid-cell-dropdown.component.html',
  styleUrls: ['./grid-cell-dropdown.component.css'],
})
export class GridCellDropdownComponent implements ICellRendererAngularComp {
  params: any;
  processId: any;
  processList = [];
  bindLabel = '';
  placeHolder = 'Process *';
  from: any;
  materialInfoData: any = [];
  materialInfoDataKey: any = [];
  materialInfoDataValues: any = [];
  materialname: any;
  constructor(private route: ActivatedRoute, private admin: AdministratorService) {}

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  agInit(params: any): void {
    this.params = params;
    this.from = params.from;
    switch (this.from) {
      case 'myProject':
        this.processId = params.data.materialId;
        this.processList = params?.defalutMaterialProjectList;
        this.bindLabel = 'description';
        break;
      case 'filling':
        this.processId = params.data.energyTypeId;
        this.processList = params?.fillingProcessList;
        this.bindLabel = 'name';
        break;
      case 'conversion':
        this.processId = params.data.energyId;
        this.processList = params?.conversionProcessList;
        this.bindLabel = 'description';
        break;
      case 'storage':
        this.processId = params.data.energyProcessId;
        this.processList = params?.storageProcessList;
        this.bindLabel = 'name';
        break;
      case 'reuse':
        this.processId = params.data.energyProcessId;
        this.processList = params?.reuseIngredientList;
        this.bindLabel = 'name';
        break;
      case 'materialIngridiant':
        this.processId = params.data.materialTypeId;
        this.processList = params?.materialIngredientList;
        this.getmaterialInfoDataTootlip(params.data.materialTypeId);
        (this.bindLabel = 'description'), (this.placeHolder = 'Material *');
        break;
      case 'materialProcess':
        this.processId = params.data.energyId;
        this.processList = params?.materialProcessList;
        this.bindLabel = 'description';
        break;
      default:
        break;
    }
  }

  commonInputSearch(term: string, item: any) {
    return item.description.toLowerCase().includes(term.toLowerCase());
  }
  commonInputSearchForName(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  updateValue(id: any) {
    this.params.data = cloneDeep(this.params.data);
    let optValue = this.params.data;
    switch (this.from) {
      case 'filling':
        optValue.energyTypeId = id;
        break;
      case 'myProject':
        optValue.materialId = id;
        break;
      case 'conversion':
        optValue.energyId = id;
        break;
      case 'storage':
        optValue.energyProcessId = id;
        break;
      case 'reuse':
        optValue.energyProcessId = id;
        break;
      case 'materialIngridiant':
        optValue.materialTypeId = id;
        break;
      case 'materialProcess':
        optValue.energyId = id;
        break;
      default:
        break;
    }
    this.params.editData(this.params.data);
  }

  getmaterialInfoDataTootlip(Id: any) {
    this.admin.GetMaterialInfo(Id, 0).subscribe((data: any) => {
      this.materialInfoData = data.data;
      this.materialname = this.materialInfoData.name;
      this.materialInfoDataKey = Object.keys(this.materialInfoData);
      this.materialInfoDataValues = Object.values(this.materialInfoData);
    });
  }
}
